import { render, staticRenderFns } from "./Spelling.vue?vue&type=template&id=397f0b2e&"
import script from "./Spelling.vue?vue&type=script&lang=js&"
export * from "./Spelling.vue?vue&type=script&lang=js&"
import style0 from "./Spelling.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports